import React, { useState } from "react";
import "./App.scss";

import {
  NodeCollectionStore,
  StaticTextNodeStore,
  VideoNodeStore,
  ImageNodeStore,
  WebNodeStore,
  AudioNodeStore,
  StoreType,
} from "./stores";

import { centerRoot } from "./Utils";
import { createAtCenter } from "./Utils";
import { FreeFormCanvas } from "./views/freeformcanvas/FreeFormCanvas";

import {
  DEFAULT_COLLECTION_WIDTH,
  DEFAULT_COLLECTION_HEIGHT,
  DEFAULT_IMAGE_WIDTH,
  DEFAULT_IMAGE_HEIGHT,
  DEFAULT_TEXT_TITLE,
  DEFAULT_IMAGE_URL,
  DEFAULT_VIDEO_URL,
  DEFAULT_WEB_URL,
  DEFAULT_AUDIO_URL,
} from "./Constants";

const mainNodeCollection = new NodeCollectionStore();

export const App: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  /**
   * This method closes the hamburger menu.
   */
  const closeMenu = () => setMenuOpen(false);

  /**
   * This method adds a node to the main collection and closes the menu.
   * @param node The node to add.
   */
  const addNode = (node: any) => {
    mainNodeCollection.addNodes([node]);
    centerRoot(mainNodeCollection, node);
    closeMenu();
  };

  /**
   * This method handles adding a text node.
   */
  const handleAddTextNode = () => {
    const title = prompt("Enter title for the node:", DEFAULT_TEXT_TITLE) ?? "";

    addNode(
      new StaticTextNodeStore({
        type: StoreType.Text,
        ...createAtCenter(),
        title,
        text: "",
      })
    );
  };

  /**
   * This method handles adding an image node.
   */
  const handleAddImageNode = () => {
    const url = prompt("Enter image URL:", DEFAULT_IMAGE_URL) ?? "";

    addNode(
      new ImageNodeStore({
        ...createAtCenter(),
        title: "Image Node",
        url,
        width: DEFAULT_IMAGE_WIDTH,
        height: DEFAULT_IMAGE_HEIGHT,
      })
    );
  };

  /**
   * This method handles adding a video node.
   */
  const handleAddVideoNode = () => {
    const url = prompt("Enter video URL:", DEFAULT_VIDEO_URL) ?? "";

    addNode(
      new VideoNodeStore({
        type: StoreType.Video,
        ...createAtCenter(),
        title: "Video Node",
        url,
      })
    );
  };

  /**
   * This method handles adding an audio node.
   */
  const handleAddAudioNode = () => {
    const url = prompt("Enter audio URL, MP4 or MP3:", DEFAULT_AUDIO_URL) ?? "";

    addNode(
      new AudioNodeStore({
        ...createAtCenter(),
        url,
      })
    );
  };

  /**
   * This method handles adding a web node.
   */
  const handleAddWebNode = () => {
    const url = prompt("Enter website URL:", DEFAULT_WEB_URL) ?? "";

    addNode(
      new WebNodeStore({
        ...createAtCenter(),
        url,
      })
    );
  };

  /**
   * This method handles adding a collection node.
   */
  const handleAddCollection = () => {
    const collection = new NodeCollectionStore();

    Object.assign(collection, {
      ...createAtCenter(),
      width: DEFAULT_COLLECTION_WIDTH,
      height: DEFAULT_COLLECTION_HEIGHT,
    });

    addNode(collection);
  };

  /**
   * This method renders the menu and the canvas.
   */
  return (
    <div className="App">
      <div className="hamburger-menu">
        <button
          className={`menu-button ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
            >
        <span />
      <span />
    <span />  
  </button>

        {menuOpen && (
          <div className="menu-dropdown">
            <button onClick={handleAddTextNode}>Add Text</button>
            <button onClick={handleAddImageNode}>Add Image</button>
            <button onClick={handleAddVideoNode}>Add Video</button>
            <button onClick={handleAddWebNode}>Add Web</button>
            <button onClick={handleAddAudioNode}>Add Audio</button>
            <button onClick={handleAddCollection}>Add Collection</button>
          </div>
        )}
      </div>

      <FreeFormCanvas store={mainNodeCollection} />
    </div>
  );
};

export default App;